import { render, staticRenderFns } from "./PhantomPlagueArticle.vue?vue&type=template&id=712cb794&"
import script from "./PhantomPlagueArticle.vue?vue&type=script&lang=js&"
export * from "./PhantomPlagueArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports